import React, { useState, useEffect } from 'react';
import { Card, Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../../common/FormUtils';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../../common/FormModal';
import TemplateService from './TemplateService';
import { v4 as uuidv4 } from 'uuid';
import schema from './jsonSchema';
import AddDayModal from './AddDayModal';
import ClassTemplateTable from './ClassTemplateTable';
const jsonSchema = schema;

const TemplateForm = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [modalAddDayShow, setModalAddDayShow] = useState(false);
  const [classTemplateDays, setClassTemplateDays] = useState([]);

  useEffect(() => {
    if (undefined !== identifier) {
      TemplateService.retrieveTemplate(identifier)
        .then(data => {
          setData(data);
          setClassTemplateDays(data.days);
          console.log(data);
        })
        .catch(error => console.log(error));
    }
  }, [identifier]);
  const handleTemplateFormSubmit = formData => {
    const updatedData = {
      ...formData,
      days: classTemplateDays
    };
    TemplateService.saveTemplate(updatedData)
      .then(response => {
        console.log(response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };
  const deleteClassTemplate = identifier => {
    setClassTemplateDays(prevDays =>
      prevDays.filter(day => day.identifier !== identifier)
    );
  };
  const handleClassTemplateDaysSubmit = classTemplate => {
    console.log('ClassTemplate added', classTemplate);
    const updatedClassTemplate = {
      ...classTemplate,
      identifier: classTemplate.identifier ? classTemplateIdentifier : uuidv4(),
      pristine: true
    };
    const list = classTemplateDays;
    list.push(updatedClassTemplate);
  };
  const buttonsConf = [
    {
      name: 'Save Class Template',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Template');
      }
    },
    {
      name: 'Add day',
      icon: 'plus',
      type: 'button',
      variant: 'success',
      onClick: () => {
        setModalAddDayShow(true);
        console.log('Add day');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator(
    'Add Class Template',
    ' ',
    buttonsConf
  );

  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'Template  has been updated!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
          redirectUrl="/app/wod/templates"
        />
      )}
      <Card className="mb-2">
        <Card.Body>
          {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleTemplateFormSubmit}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
      {classTemplateDays && (
        <ClassTemplateTable
          days={classTemplateDays}
          deleteClassTemplate={deleteClassTemplate}
        />
      )}
      <AddDayModal
        onHide={() => setModalAddDayShow(false)}
        show={modalAddDayShow}
        callback={handleClassTemplateDaysSubmit}
      />
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit, handleChange } = useFormGenerator(
    jsonSchema,
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
    <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>

  );
};
export default TemplateForm;
